import { dataAndStorageStorage } from '$logic/data-and-storage/storage'

export async function setAutoDownload(enable: boolean) {
  dataAndStorageStorage.set({ autoDownload: enable })
}
export async function setAutoPlay(enable: boolean) {
  dataAndStorageStorage.set({ autoPlayAudio: enable })
}
